import React, { useState, useEffect } from 'react'; 
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import SidebarNewsList from './SidebarNewsList';
import './ArticlePage.css';
import InstagramIcon from "../assets/icons/instagram.png";
import TwitterIcon from "../assets/icons/twitter.png";
import TelegramIcon from "../assets/icons/telegram.png";

// Separate VideoPlayer component
// Test chunck
// const VideoPlayer = ({ videoSrc, onClose }) => {
//   if (!videoSrc) return null;

//   return (
//     <div className="ArticlePage__video-player">
//       <video 
//         controls 
//         autoPlay
//         className="w-full rounded-lg shadow-lg"
//       >
//         <source src={videoSrc} type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>
//     </div>
//   );
// };


const VideoPlayer = ({ videoSrc, onClose }) => {
  if (!videoSrc) return null;

  return (
    <div className="ArticlePage__video-player">
      <video 
        controls 
        autoPlay
        className="w-full rounded-lg shadow-lg"
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};


// Separate VideoThumbnail component
const VideoThumbnail = ({ thumbnailSrc, onClick, isLoading }) => {
  if (!thumbnailSrc) return null;

  return (
    <div 
      className="ArticlePage__thumbnail-wrapper cursor-pointer"
      onClick={onClick}
      style={{ position: 'relative' }}
    >
      <img
        src={thumbnailSrc}
        alt="Video Thumbnail"
        className="ArticlePage__thumbnail"
        loading="lazy"
      />
      {isLoading ? (
        <div className="ArticlePage__loading-overlay">
          <div className="ArticlePage__loading-spinner"></div>
        </div>
      ) : (
        <div className="ArticlePage__play-icon">
          <span>▶</span>
        </div>
      )}
    </div>
  );
};

const setWithExpiry = (key, value, ttl) => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

const getWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
};


function ArticlePage() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [comments, setComments] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [videoError, setVideoError] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    comment: '',
    parent: null
  });

  // First useEffect for fetching article and comments
useEffect(() => {
  const fetchArticle = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://khanehyeghtesad.com:8000/api/article/detail2/${slug}/`
      );
      setArticle(response.data);
    } catch (error) {
      console.error('Error fetching article:', error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchComments = async () => {
    try {
      const response = await axios.get(
        `https://khanehyeghtesad.com:8000/api/comment/list/${slug}`
      );
      setComments(response.data);
    } catch (error) {
      console.error('Error fetching comments:', error);
    }
  };

  fetchArticle();
  fetchComments();
}, [slug]);

// Separate useEffect for tracking views
useEffect(() => {
  const trackView = async () => {
    if (!article || !article._id) return;

    try {
      await axios.post('https://khanehyeghtesad.com:8000/api/article/view/', {
        article_id: article._id
      });
    } catch (error) {
      console.error('Error tracking view:', error);
    }
  };

  trackView();
}, [article]); // This will run when article is loaded

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        article_id: article._id,
        name: formData.name,
        comment: formData.comment,
        email: formData.email || "",
        website_address: "", // Added website_address field
        parent: formData.parent || "",
        slug: article.slug || "" // Using article.slug
      };
  
      await axios.post(`https://khanehyeghtesad.com:8000/api/comment/new/`, payload);
  
      alert('کامنت شما با موفقیت ارسال شد!');
      setFormData({
        name: '',
        email: '',
        comment: '',
        parent: null,
      });
  
      // Clear cached comments
      localStorage.removeItem(`comments_${slug}`);
  
      // Refresh comments after successful submission
      const commentsResponse = await axios.get(
        `https://khanehyeghtesad.com:8000/api/comment/list/${article?.slug || slug}`
      );
      setComments(commentsResponse.data);
  
      // Cache the updated comments
      localStorage.setItem(`comments_${slug}`, JSON.stringify(commentsResponse.data));
    } catch (error) {
      console.error('Error submitting comment:', error);
      alert('Failed to submit comment. Please try again.');
    }
  };
  const playVideo = async (videoId) => {
    setIsVideoLoading(true);
    setVideoError(null);
  
    try {
      const response = await axios.get(
        `https://khanehyeghtesad.com:8000/api/video/article/${videoId}`
      );
  
      if (response.data?.video_file) {
        const videoSrc = response.data.video_file.startsWith('data:')
          ? response.data.video_file
          : `data:video/mp4;base64,${response.data.video_file}`;
  
        const videoData = {
          ...response.data,
          video_file: videoSrc,
        };
  
        setCurrentVideo(videoData);
      } else {
        throw new Error('No video file in response');
      }
    } catch (error) {
      console.error('Error loading video:', error);
      setVideoError('خطا در بارگذاری ویدیو. لطفا دوباره تلاش کنید.');
    } finally {
      setIsVideoLoading(false);
    }
  };
  // Test chunck
  // const playVideo = async () => {
  //   setIsVideoLoading(true);
  //   setVideoError(null);
  //   const videoId = 'ksZvl5QB6PXStfhMTJkp'; // Use your exact video ID
  //   const totalSize = 4202395; // Provided total size
  
  //   try {
  //     // Set the byte range for the first chunk (0-1260700)
  //     const rangeHeader = 'bytes=0-1260700';
  
  //     // Fetch the video chunk
  //     const videoBlob = await fetchVideoChunk(videoId, rangeHeader, totalSize);
  //     const videoUrl = URL.createObjectURL(videoBlob);
  
  //     // Set the video source
  //     setCurrentVideo({
  //       video_file: videoUrl,
  //     });
  //   } catch (error) {
  //     console.error('Error loading video:', error);
  //     setVideoError('خطا در بارگذاری ویدیو. لطفا دوباره تلاش کنید.');
  //   } finally {
  //     setIsVideoLoading(false);
  //   }
  // };
  
  // const fetchVideoChunk = async (videoId, rangeHeader, totalSize) => {
  //   try {
  //     const response = await axios.get(
  //       `https://khanehyeghtesad.com:8000/api/video/get-chunck/${videoId}/`,
  //       {
  //         headers: { Range: rangeHeader },
  //         params: { total_size: totalSize },
  //         responseType: 'blob',
  //       }
  //     );
  
  //     const videoBlob = response.data;
  //     return videoBlob;
  //   } catch (error) {
  //     throw new Error('Failed to fetch video chunk: ' + error.message);
  //   }
  // };
  

  // Helper functions
  const getImageSrc = (base64String) => {
    if (!base64String) return '/path/to/placeholder.jpg';
    try {
      return base64String.startsWith('data:') 
        ? base64String 
        : `data:image/jpeg;base64,${base64String}`;
    } catch (error) {
      console.error('Invalid Base64 image data:', error);
      return '/path/to/placeholder.jpg';
    }
  };

  // Share functions
  const handleTwitterShare = () => {
    const text = encodeURIComponent(article.title);
    const url = encodeURIComponent(window.location.href);
    window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, '_blank', 'noopener,noreferrer');
  };

  const handleTelegramShare = () => {
    const text = encodeURIComponent(article.title);
    const url = encodeURIComponent(window.location.href);
    window.open(`https://t.me/share/url?url=${url}&text=${text}`, '_blank', 'noopener,noreferrer');
  };

  const handleInstagramRedirect = () => {
    window.open('https://www.instagram.com/yourprofile/', '_blank', 'noopener,noreferrer');
  };

  if (loading) {
    return (
      <div className="ArticlePage__container">
        <h2>در حال بارگذاری...</h2>
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="ArticlePage__container">
        <h2>صفحه‌ی موردنظر یافت نشد</h2>
        <p>صفحه‌ی موردنظر شما وجود ندارد.</p>
        <Link to="/" className="ArticlePage__back-link">
          برگشت به خانه
        </Link>
      </div>
    );
  }

  // Separate out images
  let firstImage = null;
  let otherImages = [];

  if (article.image_file) {
    if (Array.isArray(article.image_file) && article.image_file.length > 0) {
      [firstImage, ...otherImages] = article.image_file;
    } else {
      firstImage = article.image_file;
    }
  }

  return (
    <div className="ArticlePage__container">
      <div className="ArticlePage__intro-flex">
        <div className="ArticlePage__media-column">
          {firstImage && (
            <figure className="ArticlePage__featured-image-wrapper">
              <img
                src={getImageSrc(firstImage)}
                alt={article.title}
                className="ArticlePage__featured-image"
                loading="lazy"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/path/to/placeholder.jpg';
                }}
              />
            </figure>
          )}

          {/* Image Gallery */}
          {otherImages.length > 0 && (
            <div className="ArticlePage__image-gallery">
              {otherImages.map((img, index) => (
                <img
                  key={`image${index}`}
                  src={getImageSrc(img)}
                  alt={`${article.title} - Image ${index + 2}`}
                  className="ArticlePage__gallery-image"
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/path/to/placeholder.jpg';
                  }}
                />
              ))}
            </div>
          )}
         
        </div>

        {/* Article Info */}
        <div className="ArticlePage__intro-text">
          <span className="ArticlePage__category">
            {article.category?.join(', ')}
          </span>
          
          <p className="ArticlePage__caption ArticlePage__caption--right">
            {article.caption}
          </p>

          <div className="ArticlePage__meta">
            <span className="ArticlePage__date">
              {article.jalali_full_date} - {article.iran_time}
            </span>
            <p className="ArticlePage__quote-short">کد خبر: {article.news_code}</p>
          </div>
          <div className="ArticlePage__social-share">
            <button
              className="ArticlePage__share-btn ArticlePage__share-btn--instagram"
              onClick={handleInstagramRedirect}
            >
              اشتراک گذاری در اینستاگرام
            </button>
            <button
              className="ArticlePage__share-btn ArticlePage__share-btn--twitter"
              onClick={handleTwitterShare}
            >
              اشتراک گذاری در توییتر
            </button>
            <button
              className="ArticlePage__share-btn ArticlePage__share-btn--telegram"
              onClick={handleTelegramShare}
            >
              اشتراک گذاری در تلگرام
            </button>
          </div>
        </div>
        
      </div>

      {/* Main Content and Sidebar */}
      <div className="ArticlePage__content-flex">
        <div className="ArticlePage__body">
          {article.quote && (
            <p className="ArticlePage__quote-short">{article.quote}</p>
          )}
          <h1 className="ArticlePage__title ArticlePage__title--right">
            {article.title}
          </h1>
          <div
            className="ArticlePage__text"
            dangerouslySetInnerHTML={{ __html: article.article }}
          />

          {/* Video Section */}
          {article.thumbnail && (
            <div className="ArticlePage__video-container" style={{ position: 'relative' }}>
              <VideoThumbnail
                thumbnailSrc={getImageSrc(article.thumbnail)}
                onClick={() => playVideo(article._id)}
                isLoading={isVideoLoading}
              />

              {videoError && (
                <div className="text-red-500 text-center my-4">
                  {videoError}
                </div>
              )}

              {currentVideo && (
                <VideoPlayer
                  videoSrc={currentVideo.video_file}
                  onClose={() => {
                    setCurrentVideo(null);
                    setVideoError(null);
                  }}
                />
              )}
            </div>
          )}

          {/* Additional Image */}
          {article.image_file2 && (
            <figure className="ArticlePage__additional-image">
              <img
                src={getImageSrc(article.image_file2)}
                alt={`${article.title} additional`}
                className="ArticlePage__image2"
                loading="lazy"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/path/to/placeholder.jpg';
                }}
              />
            </figure>
          )}

          {/* Tags */}
          {article.tags?.length > 0 && (
            <div className="ArticlePage__tags">
              <h4>کلید واژه‌ها:</h4>
              <ul className="ArticlePage__tags-list">
                {article.tags.map((tag, index) => (
                  <li key={index} className="ArticlePage__tag-item">
                    {tag}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Comments */}
          <div className="ArticlePage__comment-section">
            <h3>نظرات</h3>
            <div className="ArticlePage__comments-list">
              {comments.length > 0 ? (
                comments.map((comment) => (
                  <div key={comment.id} className="ArticlePage__comment-item">
                    <p>
                      <strong>{comment.name}</strong> - {comment.created_at}
                    </p>
                    <p>{comment.comment}</p>
                  </div>
                ))
              ) : (
                <p>نظری وجود ندارد.</p>
              )}
            </div>

            {/* Comment Form */}
            <h3>نظر بگذارید</h3>
            <form onSubmit={handleSubmit} className="ArticlePage__comment-form">
              <textarea
                name="comment"
                placeholder="نظر شما"
                value={formData.comment}
                onChange={handleChange}
                required
                className="ArticlePage__textarea"
              />

              <div className="ArticlePage__comment-fields">
                <input
                  type="text"
                  name="name"
                  placeholder="نام*"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="ArticlePage__input"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="ایمیل (اختیاری)"
                  value={formData.email}
                  onChange={handleChange}
                  className="ArticlePage__input"
                />
              </div>

              <button type="submit" className="ArticlePage__send-button">
                ارسال
              </button>
            </form>
          </div>
        </div>

        {/* Sidebar */}
        <aside className="ArticlePage__sidebar">
          <div className="connect-us-article">
            <h3 className="sidebar-title">تماس با ما</h3>
            <div className="social-box-latest">
              <div className="social-item-latest">
                <a
                  href="https://twitter.com/khanehyeghtesad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link-latest"
                >
                  <img
                    src={TwitterIcon}
                    alt="Twitter"
                    className="social-icon-latest"
                  />
                  <p>khanehyeghtesad</p>
                </a>
              </div>
              <div className="social-item-latest">
                <a
                  href="https://instagram.com/khanehyeghtesad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link-latest"
                >
                  <img
                    src={InstagramIcon}
                    alt="Instagram"
                    className="social-icon-latest"
                  />
                  <p>khanehyeghtesad</p>
                </a>
              </div>
              <div className="social-item-latest">
                <a
                  href="https://t.me/khanehyeghtesad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link-latest"
                >
                  <img
                    src={TelegramIcon}
                    alt="Telegram"
                    className="social-icon-latest"
                  />
                  <p>khanehyeghtesad</p>
                </a>
              </div>
            </div>
          </div>

          <div className="ArticlePage__world-news">
            {/* <h3>اخبار پربازدید</h3> */}
            <SidebarNewsList />
          </div>
        </aside>
      </div>
    </div>
  );
}

export default ArticlePage;
